module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/banner/id-513305f52f297e0fcd8ca34201ceeb75.jpg";